<template>
  <div id="login" class="row justify-content-center bg-general">
    <div class="col-sm-12 col-md-9 col-lg-4">
      <div class="logo stack-on-top" />
      <div class="jumbotron jumb justify-content-center d-sm-none d-md-block">
        <div v-if="alert.message" :class="`alert ${alert.type}`" role="alert">{{ alert.message }}</div>
        <form @submit.prevent="onSubmit">
          <ValidationProvider v-slot="{errors}" mode="aggressive" :rules="password.rules" persist>
            <label :for="password.name">{{ password.label }}</label>
            <input
              v-model="password.value"
              :name="password.name"
              :type="password.type"
              class="form-control"
              :class="{'is-invalid': errors[0]}"
            />
            <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{errors}"
            mode="aggressive"
            :rules="passwordConfirmation.rules"
            persist
          >
            <label :for="passwordConfirmation.name">{{ passwordConfirmation.label }}</label>
            <input
              v-model="passwordConfirmation.value"
              :name="passwordConfirmation.name"
              :type="passwordConfirmation.type"
              class="form-control"
              :class="{'is-invalid': errors[0]}"
            />
            <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
          <br />
          <primary-button title="Submit" classes="btn btn-primary btn-block" :loading="isLoading" />
          <hr />
          <router-link to="/login">
            <small>
              <strong class="text-center">Back to login</strong>
            </small>
          </router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PrimaryButton from "../../components/Buttons/PrimaryButton.vue";
import { ValidationProvider } from "vee-validate";
export default {
  name: "PasswordUpdate",
  components: {
    ValidationProvider,
    PrimaryButton
  },
  data() {
    return {
      password: {
        label: "Password",
        name: "password",
        type: "password",
        // rules: "required|phone|digits:10",
        value: ""
      },
      passwordConfirmation: {
        label: "Confirm Password",
        name: "passwordConfirmation",
        type: "password",
        value: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "passwords/isLoading"
    }),
    alert() {
      return this.$store.state.alert;
    }
  },

  methods: {
    onSubmit() {
      const { token } = this.$route.query;
      this.$store
        .dispatch("passwords/updatePassword", {
          password: this.password.value,
          passwordConfirmation: this.passwordConfirmation.value,
          token
        })
        .then(res => {
          this.$store.dispatch("alert/success", res);
          this.$router.push("/login");
        })
        .catch(err => this.$store.dispatch("alert/error", err.message));
    }
  }
};
</script>

<style scoped>
#login {
  height: 100vh;
}

.jumb {
  margin-top: 25vh;
  padding-top: 15vh;
  position: relative;
}

.logo {
  position: absolute;
  height: 76px;
  width: 76px;
  top: 0;
  left: 0;
  background: url("../../assets/images/logo.png");
}

.stack-on-top {
  z-index: 1;
  margin: 20vh 0 0 42%;
}
</style>
